// 검색 결과 파비콘 옆 한 줄(사이트 이름)과 SNS 공유 카드의 출처 라벨에 쓰이는 값.
//
// 언어별로 번역하지 않는다. 구글은 사이트 이름을 도메인당 하나만 표시하고 그 값을
// 홈(`/`)에서만 읽는데, 이 사이트의 `/` 는 설계상 영문판이라 번역 키를 쓰면 홈에서
// og:site_name 이 "Pathrade" 가 되어 _document.tsx 의 JSON-LD WebSite.name("패스레이드")과
// 어긋난다. 1순위와 2순위 후보가 엇갈리면 구글이 사이트 이름을 채택하지 않는다.
// 브랜드명 자체가 번역 대상이 아니기도 하다.
//
// 아래 세 곳이 같은 문자열을 유지해야 한다.
//   - _document.tsx 의 STRUCTURED_DATA 내 WebSite.name (정적 JSON-LD, 렌더 후에도 남는다)
//   - _document.tsx 의 og:site_name (JS 미실행 크롤러용)
//   - _app.tsx / app-layout.tsx 의 og:site_name (하이드레이션 후 Helmet)
//
// 제목(<title>)은 사이트 이름이 아니라 제목 링크용이라 계속 번역한다(common:meta.title).
// 구글이 title 에서는 구분자(| - · 등) 앞부분만 이름 후보로 쓰기 때문에 길어도 무방하다.
export const SITE_NAME = "패스레이드";
